/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Topic_Title_PlaceholderInputs */



/**
* | output |
* | --- |
* | "E.g. Results" |
*
* @param {Settings_Template_Topic_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topic_title_placeholder = /** @type {((inputs?: Settings_Template_Topic_Title_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topic_Title_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bv. Resultaten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ex. Résultats")
	return /** @type {LocalizedString} */ ("E.g. Results")
});